export var source = "fragment UserSubscriptionProgress on UserGQL {\n  subscriptionProgress {\n    status\n    subscriptionSessionId\n  }\n}";
export default source;